// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";

/**
 * Wraps any route that requires authentication.
 * Reads the token from localStorage (set by Login / Register on success).
 * If no token is found, redirects to /login and preserves the intended path
 * so the user can be sent there after signing in.
 */
export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("access_token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
